import { z } from 'zod';

export const TierSchema = z.object({
  id: z.enum(['starter', 'pro', 'institutional']),
  name: z.string(),
  tagline: z.string(),
  price: z.union([z.number().positive(), z.literal('Contact')]),
  capital: z.string(),
  strategies: z.number().int().positive(),
  featured: z.boolean().optional(),
  features: z.array(z.string()).min(3),
  excluded: z.array(z.string()),
});

export type TierRecord = z.infer<typeof TierSchema>;
